export async function copyText(value: string) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value)
      return true
    }
  } catch {
    // Some browsers expose the API on HTTP but reject calls. Use the local fallback below.
  }

  try {
    const input = document.createElement("textarea")
    input.value = value
    input.readOnly = true
    input.style.position = "fixed"
    input.style.opacity = "0"
    document.body.append(input)
    input.select()
    const copied = document.execCommand("copy")
    input.remove()
    return copied
  } catch {
    return false
  }
}
